import { BlokDynamicZone } from '@/components/storyblok/BlokProvider';

export const isChipWithLink = (item: BlokDynamicZone) =>
  item.component === 'chips' && (item.link?.url || item.link?.cached_url);
